import React, { useEffect, useRef, useState } from "react";
import { usePermissions } from "../../../common/PermissionContext";
import { Link, useLocation } from "react-router-dom";
import * as func from "../../../common/manipurCommon/FunctionCalls";
import * as api from "../../../common/manipurCommon/API";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import ImageWithBasePath from "../../../../core/data/img/ImageWithBasePath";
import Select from "react-select";
import { Button, Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from "react-bootstrap";
import Utils from "../../../common/manipurCommon/Utils";
import Swal from "sweetalert2";

const CenterAttendance = () => {

    const [attendanceList, setAttendanceList] = useState<any[]>([]);
    const [attendanceTypeList, setAttendanceTypeList] = useState<any[]>([]);
    const [athleteList, setAthleteList] = useState<any[]>([]);
    const [scheduleList, setScheduleList] = useState<any[]>([]);
    const [batchList, setBatchList] = useState<any[]>([]);
    const [programlvlList, setProgramlvlList] = useState<any[]>([]);
    const [gradeList, setGradeList] = useState<any[]>([]);
    const [athletes, setAthletes] = useState<any[]>([]);
    const [grades, setGrades] = useState<any[]>([]);
    const [stateList, setStateList] = useState<any[]>([]);
    const [districtList, setDistrictList] = useState<any[]>([]);
    const [cityList, setCityList] = useState<any[]>([]);
    const [centerList, setCenterList] = useState<any[]>([]);
    const [stateId, setStateId] = useState('');
    const [districtId, setDistrictId] = useState('');
    const [cityId, setCityId] = useState('');
    const [centerId, setCenterId] = useState('');
    const [scheduleId, setScheduleId] = useState('');
    const [batchId, setBatchId] = useState('');
    const [programlvlId, setProgramlvlId] = useState('');
    const [skillId, setSkillId] = useState('');
    const [attendanceTypeId, setAttendanceTypeId] = useState('');
    const [skillName, setSkillName] = useState('');
    const [scheduleTypeName, setScheduleTypeName] = useState('');
    const [searchInput, setSearchInput] = useState('');
    const [globalGrade, setGlobalGrade] = useState('');
    const [grade, setGrade] = useState([]);
    const [mrkAtnd, setMrkAtnd] = useState([]);
    const [comment, setComment] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [showAthletes, setShowAthletes] = useState(false);

    const formRef = useRef(null);

    const { permissionsMap } = usePermissions();
    const location = useLocation();

    const currentPath = location.pathname;
    const currentPermissions = permissionsMap[currentPath] || [];

    const customSelect = {
        control: (base) => ({
            ...base,
            // padding: '20px',
            borderRadius: '10px',
            background: '#FAFAFA',
            border: 'none',
            boxShadow: 'none', // prevents default blue border on focus
            minHeight: 'unset', // optional: removes default height if needed
        }),
        placeholder: (base) => ({
            ...base,
            color: '#aaa',
        }),
        singleValue: (base) => ({
            ...base,
            color: '#333',
        }),
        menu: (base) => ({
            ...base,
            zIndex: 9999,
        }),
    }

    useEffect(() => {
        fetchAttendance();
    }, [])

        async function fetchAttendance() {
            setIsLoading(true);
            const atndcResponse = await func.centerAttendance(null);
            setAttendanceList(Array.isArray(atndcResponse) ? atndcResponse : [])
            const atndcTypResponse = await func.attendanceType(null);
            setAttendanceTypeList(Array.isArray(atndcTypResponse) ? atndcTypResponse : []);
            const gradeResponse = await func.gradelist(null);
            setGradeList(Array.isArray(gradeResponse) ? gradeResponse : []);
            setIsLoading(false);
        }

    const filteredData = attendanceList.filter((datas) => {
        const values = Object.values(datas).map((value) =>
            value !== null && value !== undefined ? value.toString().toLowerCase() : '');
        return values.some((value) => value.includes(searchInput.toLowerCase()));
    });

    const slNoRender = (rowData, column) => {
        return column.rowIndex + 1;
    };

    const athleteNameRender = (rowData) => {
        return <span>{rowData.athleteName}</span>
    };

    const batchNameRender = (rowData) => {
        return <span>{rowData.centerBatchName}</span>
    };

    const scheduleDateRender = (rowData) => {
        return <span>{formatDate(rowData.centerScheduleDate)}</span>
    };

    const skillNameRender = (rowData) => {
        return <span>{rowData.skillName}</span>
    };

    const programlvlRender = (rowData) => {
        return <span>{rowData.programName}</span>
    };

    const gradeRender = (rowData) => {
        return <span>{rowData.gradeType}</span>
    };

    const attendancRender = (rowData) => {
        return <span>{rowData.attendanceTypeName}</span>
    };

    const formatDate = (date) => {
        const dateObj = new Date(date);
        const day = String(dateObj.getDate()).padStart(2, '0');
        const month = String(dateObj.getMonth() + 1).padStart(2, '0');
        const year = dateObj.getFullYear();
        return `${day}-${month}-${year}`;
    };

    async function athltlst(scdlId: string) {
        const athleteResponse = await func.getAthletesBySchedule(centerId, batchId, scdlId);
        setAthleteList(Array.isArray(athleteResponse) ? athleteResponse : [])
        const defaultAttendance = athleteResponse.map(() => "1");
        setMrkAtnd(defaultAttendance);
        setShowAthletes(true);
    }

    // Global handler
    const handleGlobalGradeChange = (e) => {
        const newGrade = e.target.value;
        setGlobalGrade(newGrade);
    };

    const handleGradeChange = (e, indx) => {
        // const updatedGrades = { ...grade, [indx]: e.target.value };
        const updatedGrades = [...grade]; // Make a copy of the grade array
        updatedGrades[indx] = e.target.value; // Update the specific grade at indx
        setGrade(updatedGrades);
    };

    const handleCommentChange = (e, indx) => {
        const updatedComment = { ...comment, [indx]: e.target.value };
        // console.log(updatedComment)
        setComment(updatedComment);
    };

    const markAtt = (e, indx) => {
        const updatedAttendance = { ...mrkAtnd, [indx]: e.target.value };

        // If attendance type 2 is selected, set grade to 6
        const updatedGrade = [...grade]; // Make a copy of the current grade state
        if (e.target.value === "2") {
            updatedGrade[indx] = "6"; // Set grade to 6 for the specific student (row)
        }

        setMrkAtnd(updatedAttendance)
        setGrade(updatedGrade)
    }

    function handleSubmit(e) {
        e.preventDefault();
        if (!formRef.current.checkValidity()) {
            // Manually trigger native HTML5 validation message
            formRef.current.reportValidity();
        } else {

            const attendanceDataArray: { athlete: any; typeId: string; gradeId: string; comment: string; }[] = [];

            // Populate the array with data
            athleteList.forEach((stud, index) => {
                const effectiveGrade = grade[index] || globalGrade;
                attendanceDataArray.push({
                    athlete: stud.userId,
                    typeId: mrkAtnd[index],
                    gradeId: effectiveGrade,
                    comment: comment[index] ?? "",
                });
            });

            const formData = new FormData();
            formData.append('athletes', JSON.stringify(attendanceDataArray))
            formData.append('scheduleId', scheduleId)
            formData.append('batchId', batchId)
            formData.append('programId', programlvlId)
            formData.append('skillId', skillId)

            // formData.forEach((value, key) => {
            //     console.log(`${key}: ${value}`);
            // });

            const createAtndc = api.CenterAttendance;
            fetch(createAtndc, {
                method: "POST",
                headers: {
                    "Authorization": 'Bearer ' + Utils.getAccessToken()
                },
                body: formData
            })
                .then((response) => response.json())
                .then((result) => {
                    if (result.error == false) {
                        Swal.fire({
                            title: 'Success',
                            text: result.message,
                            icon: 'success',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        }).then((res) => {
                            if (res.isConfirmed) {
                                // window.location.reload(); // 🔁 Reload only after OK is clicked
                                setOpenModal(false);
                                fetchAttendance();
                            }
                        });
                    } else {
                        if (result.code == 401) {
                            Utils.logoutUser();
                        }
                        Swal.fire({
                            title: 'Error',
                            text: result.message,
                            icon: 'error',
                            confirmButtonText: 'OK',
                            allowOutsideClick: false,
                            allowEscapeKey: false
                        })
                    }
                })
        }
    }

    async function newAttendance() {
        setIsEdit(false)
        setOpenModal(true)
        // const stateResponse = await func.listGeoStates();
        // setStateList(Array.isArray(stateResponse) ? stateResponse : [])
        const centerResponse = await func.listGeoCenters();
        setCenterList(Array.isArray(centerResponse) ? centerResponse : [])
        const athltResponse = await func.centerBatchAthelete(null);
        setAthleteList(Array.isArray(athltResponse) ? athltResponse : [])
        const progResponse = await func.program(null);
        setProgramlvlList(Array.isArray(progResponse) ? progResponse : [])
        setAthletes([]);
        const defaultAttendance = athltResponse.map(() => "1");
        setMrkAtnd(defaultAttendance);
        setBatchId("");
        setSkillId("");
        setScheduleId("");
        setProgramlvlId("");
        setAttendanceTypeId("");
        setGrades([]);
        setShowAthletes(false);
    }

    return (
        <>
            {isLoading && (
                <div id="global-loader">
                    <div className="loader-img">
                        <ImageWithBasePath src="assets/img/loader.png" className="img-fluid" alt="Global" />
                    </div>
                </div>
            )}
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Attendance</h4>
                                    {currentPermissions.includes("add") ?
                                        <Link
                                            to="#"
                                            className="btn"
                                            onClick={() => { newAttendance() }}
                                            data-bs-toggle="tooltip"
                                            style={{ fontSize: "24px", padding: "0px" }}
                                            title="Create Attendance">
                                            <i className="feather-plus" />&nbsp;
                                        </Link>
                                        : null
                                    }
                                </div>
                                <div className="col-lg-12 col-sm-12 text-end dataTables_filter">
                                    <label>
                                        <input
                                            type="text"
                                            value={searchInput}
                                            onChange={(e) => setSearchInput(e.target.value)}
                                            style={{ height: "40px" }}
                                            placeholder="Search"
                                            className="form-control"
                                        />
                                    </label>
                                </div>
                            </div>
                            <div className="tab-content">
                                <div
                                    className="tab-pane fade show active"
                                    id="nav-Recent"
                                    role="tabpanel"
                                    aria-labelledby="nav-Recent-tab"
                                    tabIndex={0}
                                >
                                    <div className="table-responsive table-datatble">
                                        <DataTable
                                            className="table datatable"
                                            value={filteredData}
                                            paginator
                                            rows={10}
                                            rowsPerPageOptions={[10, 25, 50, 100]}
                                            // currentPageReportTemplate="{first}- {last} of {totalRecords} entries"
                                            pageLinkSize={3}
                                        >
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="slNo"
                                                body={slNoRender}
                                                header="Sl &nbsp; No"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="athleteName"
                                                header="Athlete Name"
                                                body={athleteNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="centerBatchName"
                                                header="Batch Name"
                                                body={batchNameRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="centerScheduleDate"
                                                header="Schedule Date"
                                                body={scheduleDateRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            {/* <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="skillName"
                                                header="Skill Name"
                                                body={skillNameRender}
                                                className="table-inset-btn"
                                            ></Column> */}
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="programName"
                                                header="Program Name"
                                                body={programlvlRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="attendanceTypeName"
                                                header="Attendance Type"
                                                body={attendancRender}
                                                className="table-inset-btn"
                                            ></Column>
                                            <Column
                                                sortable
                                                headerClassName="text-uppercase"
                                                field="gradeType"
                                                header="Grade"
                                                body={gradeRender}
                                                className="table-inset-btn"
                                            ></Column>
                                        </DataTable>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {openModal && (
                <Modal
                    show={openModal}
                    size="xl"
                    scrollable
                    centered>
                    <ModalHeader>
                        <ModalTitle>
                            <h4 className="mb-0 upper-case">{isEdit ? "Edit " : "Add "} Attendance</h4>
                        </ModalTitle>
                        <Button
                            variant=""
                            className="btn-close"
                            onClick={() => {setOpenModal(false);fetchAttendance();}}
                        ></Button>
                    </ModalHeader>
                    <ModalBody>
                        <form ref={formRef}>
                            <div className="row">
                                {/* <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">State Name</label>
                                        <Select
                                            value={stateList.find(state => state.geographyId === stateId) ? {
                                                value: stateId,
                                                label: stateList.find(state => state.geographyId === stateId).geographyName
                                            } : null}
                                            onChange={async (e) => {
                                                setStateId(e.value);
                                                const response = await func.listGeoDistrictByStateId(e.value);
                                                setDistrictList(Array.isArray(response) ? response : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select State"
                                            options={stateList.map(state => ({
                                                value: state.geographyId,
                                                label: state.geographyName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">District Name</label>
                                        <Select
                                            value={districtList.find(dist => dist.geoDistrictsId === districtId) ? {
                                                value: districtId,
                                                label: districtList.find(dist => dist.geoDistrictsId === districtId).geoDistrictsName
                                            } : null}
                                            onChange={async (e) => {
                                                setDistrictId(e.value);
                                                const response = await func.listGeoCityByDistrictId(e.value);
                                                setCityList(Array.isArray(response) ? response : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select District"
                                            options={districtList.map(dist => ({
                                                value: dist.geoDistrictsId,
                                                label: dist.geoDistrictsName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">City</label>
                                        <Select
                                            value={cityList.find(city => city.geoCityId === cityId) ? {
                                                value: cityId,
                                                label: cityList.find(city => city.geoCityId === cityId).geoCityName
                                            } : null}
                                            onChange={async (e) => {
                                                setCityId(e.value);
                                                const cntrResponse = await func.listGeoCentersByCityId(e?.value);
                                                setCenterList(Array.isArray(cntrResponse) ? cntrResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select City"
                                            options={cityList.map(city => ({
                                                value: city.geoCityId,
                                                label: city.geoCityName
                                            }))}>
                                        </Select>
                                    </div>
                                </div> */}
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">Center</label>
                                        <Select
                                            value={centerList.find(center => center.geoCenterId === centerId) ? {
                                                value: centerId,
                                                label: centerList.find(center => center.geoCenterId === centerId).geoCenterName
                                            } : null}
                                            onChange={async (e) => {
                                                setCenterId(e.value);
                                                const batchResponse = await func.getBatchesByCenter(e.value);
                                                setBatchList(Array.isArray(batchResponse) ? batchResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Center"
                                            options={centerList.map(center => ({
                                                value: center.geoCenterId,
                                                label: center.geoCenterName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">Batch Name</label>
                                        <Select
                                            value={batchList.find(btch => btch.centerBatchId === batchId) ? {
                                                value: batchId,
                                                label: batchList.find(btch => btch.centerBatchId === batchId).centerBatchName
                                            } : null}
                                            onChange={async (e) => {
                                                setBatchId(e.value);
                                                const batchResponse = await func.getScheduleByBatchandCenter(centerId, e.value);
                                                setScheduleList(Array.isArray(batchResponse) ? batchResponse : [])
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Batch"
                                            options={batchList.map(btch => ({
                                                value: btch.centerBatchId,
                                                label: btch.centerBatchName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">Program Level</label>
                                        <Select
                                            value={programlvlList.find(prog => prog.programId === programlvlId) ? {
                                                value: programlvlId,
                                                label: programlvlList.find(prog => prog.programId === programlvlId).programName
                                            } : null}
                                            onChange={(e) => {
                                                setProgramlvlId(e.value);
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Program"
                                            options={programlvlList.map(prog => ({
                                                value: prog.programId,
                                                label: prog.programName
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                                <div className="col-lg-3">
                                    <div className="input-space">
                                        <label className="form-label">Schedule</label>
                                        <Select
                                            value={scheduleList.find(scdl => scdl.centerScheduleId === scheduleId) ? {
                                                value: scheduleId,
                                                label: formatDate(scheduleList.find(scdl => scdl.centerScheduleId === scheduleId).centerScheduleDate)
                                            } : null}
                                            // onChange={(e) => {
                                            //     setScheduleId(e.value);
                                            // }}
                                            onChange={async (e) => {
                                                setScheduleId(e.value)
                                                athltlst(e.value)
                                                const selectedSchedule = scheduleList.find(
                                                    (scdl) => scdl.centerScheduleId === e.value
                                                );

                                                if (selectedSchedule) {
                                                    setScheduleTypeName(selectedSchedule.scheduleTypeName);
                                                    setSkillName(selectedSchedule.skillName);
                                                    setSkillId(selectedSchedule.centerScheduleSkillId)
                                                }
                                            }}
                                            required
                                            styles={customSelect}
                                            placeholder="Select Schedule"
                                            options={scheduleList.map(scdl => ({
                                                value: scdl.centerScheduleId,
                                                label: formatDate(scdl.centerScheduleDate)
                                            }))}>
                                        </Select>
                                    </div>
                                </div>
                            </div>
                            {showAthletes && (
                                <>
                                    <div className="row col-md-12 ">
                                        <p className="mb-1"><b>Skill Taught - </b>{skillName} <b>Schedule Type - </b>{scheduleTypeName}</p>
                                    </div>
                                    <div className="row">
                                        <div className="table-responsive table-datatble">
                                            <table className="table datatble">
                                                <thead className="thead-light">
                                                    <tr>
                                                        <th className="text-upper">Name</th>
                                                        <th className="text-upper">Attendance</th>
                                                        <th className="text-upper">Grade
                                                            <select value={globalGrade} onChange={handleGlobalGradeChange}>
                                                                <option value="" disabled>Select Grade</option>
                                                                {gradeList.map((grd) => (
                                                                    <option key={grd.gradeTypeId} value={grd.gradeTypeId}>
                                                                        {grd.gradeType}
                                                                    </option>
                                                                ))}
                                                            </select>
                                                        </th>
                                                        <th className="text-upper">Comment</th>
                                                    </tr>
                                                    {Array.isArray(athleteList) && athleteList.map((stud, index) => (
                                                        <tr key={index}>
                                                            <td>{stud.athleteName}</td>
                                                            <td style={{ paddingRight: '4rem' }}>
                                                                {Array.isArray(attendanceTypeList) && attendanceTypeList.map((atndc) => (
                                                                    <div key={atndc.attendanceTypeId} className="form-check form-check-inline">
                                                                        <input
                                                                            type="radio"
                                                                            id={`attendance_${index}_${atndc.attendanceTypeId}`}
                                                                            value={atndc.attendanceTypeId}
                                                                            checked={mrkAtnd[index] === String(atndc.attendanceTypeId)}
                                                                            onChange={(e) => markAtt(e, index)}
                                                                            className="form-check-input default-check me-2"
                                                                        />
                                                                        <label>{atndc.attendanceTypeName}</label>
                                                                    </div>
                                                                ))}
                                                            </td>
                                                            <td>
                                                                <select
                                                                    value={grade[index] !== undefined && grade[index] !== '' ? grade[index] : globalGrade}
                                                                    onChange={(e) => handleGradeChange(e, index)}
                                                                >
                                                                    <option value="">Select Grade</option>
                                                                    {gradeList.map((grd) => (
                                                                        <option key={grd.gradeTypeId} value={grd.gradeTypeId}>
                                                                            {grd.gradeType}
                                                                        </option>
                                                                    ))}
                                                                </select>
                                                            </td>
                                                            <td>
                                                                <input
                                                                    type="text"
                                                                    style={{ border: "1px solid hsl(0, 0%, 80%)", height: "25px" }}
                                                                    value={comment[index]}
                                                                    onChange={(e) => handleCommentChange(e, index)}
                                                                />
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </thead>
                                            </table>
                                        </div>
                                    </div>
                                </>
                            )}

                            <ModalFooter>
                                <Button
                                    className="btn-primary text-uppercase"
                                    variant="success"
                                    type="submit"
                                    onClick={handleSubmit}
                                >
                                    <b><i className="fas fa-save" />Save</b>
                                </Button>
                            </ModalFooter>
                        </form>
                    </ModalBody>
                </Modal>
            )}
        </>
    );
};

export default CenterAttendance;